import "./index.scss";

import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import Bell from "assets/img/svg/navbar/bell";
import { useIsPWA } from "hooks/usePWAMode";
import { useTranslation } from "react-i18next";
import { toggleNotificationsDrawer, toggleSettingsTab, toggleTitleDrawer } from "store/settingsStore";
import { useAppDispatch, useAppSelector } from "store/store";

/**
 * Render btn to toggle navbar on BP mobile phone/tablet
 */
interface IBPMobileNavBtn {
    /**
     * React state boolean to show nav drawer
     */
    openNavDrawer: () => void;
    onOpenNavDrawer: boolean;
    closeNavDrawer: () => void;
}

export const BPMobileNavBtn = ({ openNavDrawer, onOpenNavDrawer, closeNavDrawer }: IBPMobileNavBtn) => {
    const [t] = useTranslation();
    const onOpenNotificationsDrawer = useAppSelector((state) => state.settings.showNotificationsDrawer);
    const dispatch = useAppDispatch();
    const isPWAMode = useIsPWA();

    const openNotifications = () => {
        dispatch(toggleNotificationsDrawer(!onOpenNotificationsDrawer));
        displayMobileNavBtn(onOpenNotificationsDrawer);
    };

    const onOpenDrawer = () => {
        openNavDrawer();
        setTimeout(() => {
            dispatch(toggleTitleDrawer(false));
            dispatch(toggleSettingsTab(false));
        }, 200);
    };

    return (
        <div
            className={`BP-mobile-navigation-btn ${!isPWAMode ? "bottom-10" : ""}`}
            style={onOpenNavDrawer ? { padding: "0" } : {}}
            onClick={onOpenNavDrawer ? closeNavDrawer : () => {}}
        >
            <div className={`drawer-off-btn-content`}>
                <div
                    className="btn-left"
                    onClick={onOpenDrawer}
                    style={onOpenNavDrawer ? { borderRight: "none", paddingRight: "0" } : {}}
                >
                    <CloseIcon
                        className={onOpenNavDrawer ? "show-nav-btn-content" : "hide-nav-btn-content"}
                        style={{ width: "1em", height: "1em" }}
                    />
                    <span>{onOpenNavDrawer ? t("BPDashboard.Close") : t("BPDashboard.Menu")}</span>
                    {!onOpenNavDrawer && <MenuIcon />}
                </div>
                {!onOpenNavDrawer && (
                    <div className="btn-right" onClick={() => openNotifications()}>
                        <NotificationsIcon />
                    </div>
                )}
            </div>
        </div>
    );
};

const NotificationsIcon = () => {
    const { notifications = [] } = useAppSelector((state) => state.notification);
    return (
        <div className="navigation-link">
            <div className="navigation-link-icon">
                <Bell />
            </div>
            {!!notifications.filter((notif) => !notif.seen).length && (
                <div className="notifications-badge">{notifications.filter((notif) => !notif.seen).length}</div>
            )}
        </div>
    );
};

export const displayMobileNavBtn = (visible: boolean) => {
    const button: HTMLDivElement | null = document.querySelector(".BP-mobile-navigation-btn");
    if (visible) {
        button?.classList.remove("hide-btn");
    } else {
        button?.classList.add("hide-btn");
    }
};
